export const hospitalPerformingPhysicianColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'code',
  'fk_hospital__procedures_id',
  'name',
  'npi',
  'snapshot_id',
  'specialty',
];
